<template>
  <div class="exhibitionRecord">
    <el-col class="userinfoList infoPub" style="width: 990px">
      <div class="exhContent">
        <!-- 搜索组件 -->
        <search-bar
          :selectType="ExhIndexType"
          :searchInputPlc="searchInputPlc"
          :searchSelectPlc="searchSelectPlc"
          @changeExhibitionState="toSearch"
          @toSearch="toSearch"
        ></search-bar>
        <!--提示信息-->
        <div class="prompt-info-wrap">
          <div
            class="prompt-info"
            v-if="lan == 'ch'"
          >
            1、观展前，请确保您使用的参展电脑配有摄像头，耳机和麦克风设备。
          </div>
          <div
            class="prompt-info"
            v-if="lan == 'ch'"
          >
            2、观展时，请使用谷歌浏览器打开展会官网，如需安装，<span
              class="download"
              @click="download"
            >
              {{ language.down }}
            </span>
          </div>
        </div>
        <!-- table -->
        <pub-table
          :columns="columns"
          :tableData="cloneTicktsData"
          :loading="loading"
          :ticketMan="ticketMan"
        >
          <!-- 复制票号行 -->
          <template v-slot:exhticket_num="exhticketNum">
            <el-tooltip
              class="item"
              effect="dark"
              :content="language.copyTic"
              placement="top-start"
            >
              <svg-icon
                icon-class="copy"
                class="el-input__icon input-icon"
                style="cursor: pointer;margin-right: 2px"
                @click="copyNum(exhticketNum)"
              />
            </el-tooltip>
          </template>
          <template v-slot:action="dataList">
            <!-- <el-tooltip
              class="item"
              effect="dark"
              :content="language.enternotes"
              placement="top"
            > -->
              <el-button
                type="primary"
                size="mini"
                @click="getJoin(dataList)"
                style="outline: none;background:#0071ff;border:none;cursor:pointer;color:#fff;border-radius:5px;font-size:14px"
                >{{ language.enter1 }}</el-button>
<!--              <el-button-->
<!--                v-if="dataList.dataList.send_user_id=='0'"-->
<!--                type="primary"-->
<!--                size="mini"-->
<!--                @click="shareClick(dataList)"-->
<!--                style="outline: none;background:#FF9E00;border:none;cursor:pointer;color:#fff;border-radius:5px;font-size:14px"-->
<!--                >{{ language.share }}</el-button>-->
<!--                <el-button-->
<!--                v-if="dataList.dataList.send_user_id!='0' && userInfo.user_id == dataList.dataList.user_id"-->
<!--                type="primary"-->
<!--                size="mini"-->
<!--                @click="recyclingClick(dataList.dataList)"-->
<!--                style="outline: none;background:#FF9E00;border:none;cursor:pointer;color:#fff;border-radius:5px;font-size:14px"-->
<!--                >{{ language.takeBack }}</el-button>-->
            <!-- </el-tooltip> -->
          </template>
        </pub-table>
        <!-- page -->
        <table-page
          :pageSize="pageSize"
          :layout="layout"
          :pageTotal="pageTotal"
          :currentPage="currentPage"
          @pageChange="pageChange"

        ></table-page>

      </div>
    </el-col>
    <el-dialog
      :visible="showShare"
      :title="language.ShareTicket"
      @update:visible="updateVisiable($event)"
      width="1000px"
      :show-close="true"
      class="hint_dialog"
    >
      <div class="share-title">{{language.Sharelinks}}</div>
      <div class="pc-url-div">
        <p id="copy_pc_url">{{shareLink}}</p>
      </div>
      <div class="url-formBtn">
        <el-button
          type="warning"
          class="pc-url-formBtn"
          @click.native="copyPcUrl"
          v-if="lan == 'ch'"
          >复制</el-button
        >
        <el-button
          type="warning"
          class="pc-url-formBtn"
          @click.native="copyPcUrl"
          v-else
          >Copy</el-button
        >
      </div>
      <div class="share-title">{{language.appletCode}}</div>
      <div style="padding-top:10px;">{{language.appletContent}}</div>
      <div >
        <img class="share-img" :src="shareWxQr"/>
      </div>
      <div class="url-formBtn" style="margin-top: 20px;border-bottom:0;">
        <el-button
          type="warning"
          class="pc-url-formBtn"
          @click.native="imgDown(shareWxQr)"
         >{{language.download}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {MessageBox} from 'element-ui';
import { language } from "../../../language/get";
import { ExhIndexType } from "../../../common/constant/exhibition";
import { getGzExhTicketList, ExhticketRecovery } from "../../../api/tickets";
import { ExhibitionType } from "../../../common/constant/exhibition";
import searchBar from "../components/searchbar/searchbar";
import pubTable from "../components/table/table";
import tablePage from "../components/tablepage/tablepage";
const pubLanguage = language();
import Cookies from "../../../common/cookie";
import { getBroadcastClass } from "../../../api/exhibition";
import Axios from "axios";
import reqest from "../../../common/reqest";
import {mapGetters} from "vuex";

export default {
  components: {
    searchBar,
    pubTable,
    tablePage,
  },
  data() {
    return {
      shareWxQr: '',
      shareLink: '',
      showShare: false,
      language: language(),
      lan: Cookies.get("lang"),
      loading: true,
      ticketMan: true,  //门票管理的表格
      pageTotal: 0,
      pageSize: 6,
      currentPage: 1,
      layout: "prev, pager, next, jumper",
      //搜索相关
      ExhIndexType,
      searchInputPlc: pubLanguage.fairName,
      searchSelectPlc: pubLanguage.state,
      //搜索条件
      getStateCon: null,
      getValCon: null,
      //table 表头
      columns: [
        {
          title: pubLanguage.ticName,
          key: "exh_name",
          width: "290",
        },
        {
          title: pubLanguage.exhibitionTime,
          key: "exh_time",
          width: "280",
        },
        {
          title: pubLanguage.price,
          key: "exhticket_price",
          width: "120",
        },
        // {
        //   title: '门票类型',
        //   key: "order_type",
        //   width: "120",
        // },
        {
          title: pubLanguage.buyTime,
          key: "pay_time",
          width: "160",
        },
        {
          title: pubLanguage.operation,
          key: "action",
          width: "200",
        },
      ],
      ticktsData: [],
      cloneTicktsData: [],
    };
  },

  computed: {
    ...mapGetters(["userInfo"]),
  },
  created() {
    this.exhTicketList();
  },
  methods: {
    imgDown(url) {
      this.downloadIamge(url, '分享二维码.png')
      //location.href = url;
    },
    // 跨域文件下载
    downloadIamge(url, fileName) {
      url = url.replace(/\\/g, "/");
      const xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "blob";
      //xhr.setRequestHeader('Authorization', 'Basic a2VybWl0Omtlcm1pdA==');
      xhr.onload = () => {
        if (xhr.status == 200) {
          let data = xhr.response;
          let name = fileName;

          var urlObject = window.URL || window.webkitURL || window;
          var export_blob = new Blob([data]);
          var save_link = document.createElementNS(
            "http://www.w3.org/1999/xhtml",
            "a"
          );
          save_link.href = urlObject.createObjectURL(export_blob);
          save_link.download = name;
          save_link.click();
        }
      };

      xhr.send();
    },
    recyclingClick(item){
      let _this = this;
      MessageBox({
        title: "",
        message: language().takeBackTip,
        confirmButtonText: language().confirm,
        cancelButtonText: language().cancel,
        dangerouslyUseHTMLString:true,
        showCancelButton: true,
        // type: 'warning'
      }).then(() => {
        //确认
        _this.recyclingOk(item.exhticket_user_id);
      }).catch(() => {
        //取消
      });
    },
    recyclingOk(id) {
      let data = {
        token: this.$store.state.user.token,
        exhticket_user_id: id
      };
      ExhticketRecovery(data).then(res => {
        if (res.type == "1") {
          this.exhTicketList();
        } else {
          if (this.lan == "ch") {
            return this.$message.error({message: res.text, offset: 120})
          }
          return this.$message.error({message: res.text_en, offset: 120})
        }
      });
    },
    updateVisiable(e){
      this.showShare = e;
    },
    copyPcUrl() {
      let url = this.shareLink;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: this.lan == 'ch'?"复制成功":"Copy succeeded",
        type: "success",
      });
      oInput.remove();
    },
    //复制票号
    copyNum(numData) {
      let copyData = numData.exhticketNum;
      this.copy(copyData);
    },
    copy(data) {
      let url = data;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      //console.log(oInput.value)
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: this.lan == 'ch'?"复制成功":"Copy succeeded",
        type: "success",
        offset: 100,
      });
      oInput.remove();
    },
    //搜索切换
    toSearch( val, state) {
      // console.log("搜索结果==" + state + " " + val);
      this.getStateCon = state;
      this.getValCon = val;
      this.currentPage = 1;
      this.exhTicketList();
    },
    //分页
    pageChange(val) {
      this.currentPage = val;
      this.exhTicketList();
    },
    //展会门票列表
    exhTicketList() {
      let that = this;
      let data = {
        token: this.$store.state.user.token,
        type: this.getStateCon,
        lan: this.lan,
        keyword: this.getValCon,
        currentPage: this.currentPage,
        numberPage: this.pageSize,
      };
      getGzExhTicketList(data).then((res) => {
        if (res.type != "1") {
          if (this.lan == "ch") {
            return this.$message.error({ message: res.text, offset: 120 });
          }
          return this.$message.error({ message: res.text_en, offset: 120 });
        }
        if (!res.data) {
          this.ticktsData = [];
          this.cloneTicktsData = [];
          this.pageTotal = 0;
          this.loading = false;
          return;
        }
        res.data.forEach((item) => {
          if (this.lan == "en") {
            item.exh_name = `${item.exh_name_en}`;
            item.exh_begtime = `${item.exh_begtime_en}`;
            item.exh_endtime = `${item.exh_endtime_en}`;
            item.pay_time = `${item.pay_time_en}`;
          }
          item.order_type = item.order_type==5?'招聘会个人报名':'门票';
          item.exh_time = `${item.exh_begtime} ${this.language.to} ${item.exh_endtime}`;
          item.exhticket_price = `${item.exhticket_price}${this.language.CNY}/${this.language.site1}`;
        });
        this.ticktsData = res.data;
        this.cloneTicktsData = res.data;
        this.pageTotal = Number(res.datacount);
        this.loading = false;
        // console.log("门票管理" , this.cloneTicktsData);
      });
    },
    //下载谷歌浏览器
    download() {
      window.open(
        "https://www.google.cn/intl/zh-CN/chrome/?brand=CHBD&gclid=EAIaIQobChMI_JKx1J2Z6QIVjqmWCh2-qwpkEAAYASAAEgKlBvD_BwE&gclsrc=aw.ds"
      );
    },
    shareClick(data){
      let encodeData = window.btoa(window.encodeURIComponent("exhticket_user_id="+data.dataList.exhticket_user_id));
      this.showShare = true;
      let nowUrl = location.href.substring(0, location.href.lastIndexOf('.html'));
      nowUrl = nowUrl.substring(0, nowUrl.lastIndexOf('/'));
      this.shareLink = nowUrl+"/shareExhticket.html?"+encodeData;
      this.shareWxQr = reqest.adminapi+'MakeQr/getShareTicketQr?exhticket_user_id='+data.dataList.exhticket_user_id;
    },
    getJoin(data) {
      window.location.href =
        "forum.html" + "?exhibition_id=" + data.dataList.exhibition_id;
    },
  },
};
</script>

<style scoped>
.exhibitionRecord >>> .tableNode {
  padding: 30px 20px;
  border-radius: 5px;
  margin-top: 10px;
}
.exhibitionRecord >>> .prompt-info-wrap {
  background: #fff;
  padding: 25px 0 28px 15px;
  border-radius: 5px;
  margin-top: 10px;
}
.exhibitionRecord >>> .prompt-info {
  height: 30px;
  line-height: 30px;
  background: #fff;
  padding-left: 0;
  color: #f47900;
  font-size: 18px;
  font-weight: bold;
}
.exhibitionRecord >>> .prompt-info span {
  color: #0071ff;
  cursor: pointer;
}
.exhibitionRecord >>> .page {
  margin-left: 0px;
}
.pc-url-div {
  margin: 30px auto;
  width: 800px;
  height: 80px;
  line-height: 80px;
  border-radius: 10px;
  background: #ececec;
  color: #000;
  display: block;
  padding: 0px 50px;
  /* margin: 0 auto; */
}
.share-title{
  padding: 0px 10px;
  font-weight:bold;
  border-left: 5px solid #0c6dce;
  font-size:18px;
}
.share-img{
  display: block;
  height: 150px;
  width: auto;
  margin: 0px auto;
}

.url-formBtn{
  border-bottom:1px solid #eee;
  padding-bottom:20px;
  margin-bottom:10px;
}

</style>
